// Valeurs par défaut pour toutes les marques

export const DEFAULT_BRAND = 'audi';

export const DEFAULT_CONFIG = {
  // Configuration par défaut de l'application
  app: {
    maxCommentLength: 200,
    sessionStorageKey: 'rdv_live',
    maxWorkingDaysAhead: 10,
  },

  // Messages par défaut
  messages: {
    loading: 'Chargement des disponibilités...',
    loadingAvailabilities: 'Chargement des disponibilités...',
    errorLoading: 'Erreur lors du chargement des données',
    errorAppointment:
      'Nous rencontrons actuellement un problème lors de la prise de votre rendez-vous. Nous vous prions de bien vouloir réessayer ultérieurement. Nous nous excusons pour ce désagrément.',
    errorTicketNotFound: 'Rendez-vous créé, mais ticket introuvable',
    errorDataLoading: 'Impossible de charger les données.',
    errorZendeskIdMissing:
      'Erreur : ID Zendesk manquant. Veuillez contacter le support.',
    errorCommentInvalid:
      'Erreur : Le commentaire contient des caractères non autorisés. Veuillez modifier votre message.',
    confirmationTitle: 'Merci de votre confiance !',
    confirmationSubtitle: 'Votre rendez-vous est confirmé',
    returnToMenu: 'Retour au menu',
    returnToMainMenu: 'Revenir au menu principal',
    retry: 'Réessayer',
    dateLabel: 'Date',
    mainTitle: 'Réservez votre date',
    timeSelectionTitle: 'Sélectionnez un créneau horaire',
    commentPlaceholder:
      'Ajoutez un commentaire à transmettre à votre conseiller',
    confirmButton: 'Confirmer ma réservation',
    breadcrumbDate: 'Date',
    breadcrumbSlot: 'Créneau',
    breadcrumbSeparator: ' > ',
    rgpdText:
      'Pour en savoir plus sur la gestion de vos données personnelles et pour connaître vos droits et les exercer, reportez-vous à la ',
    rgpdLinkText: 'Charte des Données Personnelles',
    testConfirmation: 'Tester la confirmation',
    resetToToday: "Réinitialiser à aujourd'hui",
    dateSimulator: 'Simulateur de date',
  },

  // Design par défaut avec palette complète
  design: {
    fontFamily: 'Arial',

    // Couleurs principales
    primaryColor: '#000000',
    secondaryColor: '#ffffff',
    accentColor: '#f5d11f',

    // Couleurs de texte
    textPrimary: '#000000',
    textSecondary: '#666666',
    textRgpdColor: '#707070',
    textDisabled: '#b3b3b3',

    // Couleurs de fond
    backgroundPrimary: '#ffffff',
    backgroundSecondary: '#f5f5f5',
    backgroundHover: '#f0f0f0',
    backgroundSelected: '#000000',

    // Couleurs des bordures
    borderPrimary: '#e0e0e0',
    borderSecondary: '#cccccc',
    borderFocus: '#000000',

    // Couleurs d'état
    successColor: '#28a745',
    errorColor: '#dc3545',
    warningColor: '#ffc107',
    infoColor: '#17a2b8',

    // Couleurs des boutons
    buttonPrimary: '#000000',
    buttonPrimaryHover: '#333333',
    buttonSecondary: '#ffffff',
    buttonSecondaryHover: '#f5f5f5',
    buttonDisabled: '#cccccc',

    // Couleurs du calendrier
    calendarHeader: '#666666',
    calendarDay: '#000000',
    calendarDayHover: '#f5f5f5',
    calendarDaySelected: '#000000',
    calendarDayDisabled: '#b3b3b3',

    // Couleurs des créneaux horaires
    timeSlot: '#ffffff',
    timeSlotHover: '#f5f5f5',
    timeSlotSelected: '#000000',
    timeSlotDisabled: '#b3b3b3',
  },

  // Données de test par défaut
  testData: {
    confirmationDate: '18 / 09 / 2025',
    confirmationTime: '12 : 30',
  },
};
